export default __webpack_public_path__ + "static/media/Logo-ANSO-08-1.5f14279e.png";